/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-27 11:17:26
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-20 16:49:21
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/ModalHOC/index.tsx
 */
/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-26 14:36:13
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-26 22:32:13
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/BulkEditorTable/SeachConditionsHOC.tsx
 */
//modalClassName
import React, { useState, ReactNode } from 'react';
import { Modal } from 'src/components/Antd';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';

const ModalHOC = (Comp, config?) => {
  const { width, responsiveHeight } = config || {};
  const WrapperComp = (props) => {
    const i18n = useI18n();
    const getI18n = (str) => i18nGet(i18n, str);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [modalTitle, setModalTitle] = useState<string | ReactNode>('');
    const [modalContent, setModalContent] = useState<ReactNode>('');
    const [w, setWidth] = React.useState(width || 600);

    const onModalCancel = () => {
      setShowModal(false);
      setModalContent(null);
    };

    const modalOp = {
      setShowModal,
      setModalTitle,
      setModalContent,
      onModalCancel,
      setWidth,
    };
    return (
      <React.Fragment>
        <Modal
          className={responsiveHeight ? css.modalClassName : ''}
          width={w}
          visible={showModal}
          title={modalTitle}
          onCancel={onModalCancel}
          cancelText={getI18n('general.cancel')}>
          {showModal ? modalContent : null}
        </Modal>
        {<Comp modalOp={modalOp} {...props} />}
      </React.Fragment>
    );
  };
  return WrapperComp;
};
export default ModalHOC;

// const useModals = (config) => {
//   const { width } = config;
//   const [showModal, setShowModal] = useState<boolean>(false);
//   const [modalTitle, setModalTitle] = useState<string | ReactNode>('');
//   const [modalContent, setModalContent] = useState<ReactNode>('');
//   const [w, setWidth] = React.useState(width || 600);
//   const onModalCancel = () => {
//     setShowModal(false);
//     setModalContent(null);
//   };

//   const modalOp = {
//     setShowModal,
//     setModalTitle,
//     setModalContent,
//     onModalCancel,
//     setWidth,
//   };
//   return (
//     <React.Fragment>
//       <Modal
//         width={w}
//         visible={showModal}
//         title={modalTitle}
//         onCancel={onModalCancel}
//         cancelText='Cancel'>
//         {showModal ? modalContent : null}
//       </Modal>
//     </React.Fragment>
//   );
//   return modalOp;
// };
